const defaultState = {
  socio: {
    dni: 33134865,
    nombre: "SANTIAGO ALARCON",
    plan: "5e29e3e515cbc6637e99d567",
    version: "5e29e3e515cbc63ef599d568",
  },
  plan: null,
  allPrestaciones: null,
  listaDePrecios: null,
  historialSocio: [],
  validaciones: [],
  carrito: [],
  mascotas: [],
  cantidadMascotas: 0,
  alerta: "",
  nombrePlan: "",
  servicios_prestador: null,
  idPrestador: null,
  comprobante: null,
  contratos: null,
  SOCIO_CON_DEUDA: null,
  integrantes: [],
  isGuardia: false,
  cartelGuardia: "",
  admite_pagos_con_tarjeta: false,
  alimento_consumido: null,
  servicios_comprobante: null,
  loading: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_PLAN_SOCIO":
      return {
        ...state,
        plan: {
          ...action.payload.plan,
          versiones: action.payload.plan.versiones.filter(
            (v) => v._id === action.payload.version
          ),
        },
        nombrePlan: action.payload.nombrePlan,
      };
    case "GET_PRESTACIONES_SOCIO":
      return {
        ...state,
        allPrestaciones: action.payload,
      };
    case "GET_PRESTADOR_PRECIOS":
      return {
        ...state,
        listaDePrecios: action.payload,
      };
    case "VALIDAR_REGLAS":
      return {
        ...state,
        validaciones: state.validaciones.concat(action.payload),
      };
    case "CLEAN_VALIDACIONES":
      return {
        ...state,
        validaciones: [],
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: true
      }
    case "ADD_CARRITO":
      return {
        ...state,
        carrito: state.carrito.concat(action.payload.linea),
        loading: false,
        historialSocio: state.historialSocio.map((h) => {
          return h.idPrestacion == action.payload.idGrupo
            ? {
              ...h,
              cantidadMensual:
                h.cantidadMensual + parseInt(action.payload.linea.cantidad),
              cantidadAnual:
                h.cantidadAnual + parseInt(action.payload.linea.cantidad),
              cantidadAnual_socio:
                h.cantidadAnual_socio +
                parseInt(action.payload.linea.cantidad),
              cantidadMensual_socio:
                h.cantidadMensual_socio +
                parseInt(action.payload.linea.cantidad),
            }
            : h;
        }),
      };
    case "DEL_ITEM_CARRITO":
      return {
        ...state,
        historialSocio: state.historialSocio.map((h) => {
          return h.idPrestacion == action.payload.idGrupo
            ? {
              ...h,
              cantidadMensual:
                h.cantidadMensual - parseInt(action.payload.cantidad),
              cantidadAnual:
                h.cantidadAnual - parseInt(action.payload.cantidad),
              cantidadAnual_socio:
                h.cantidadAnual_socio - parseInt(action.payload.cantidad),
              cantidadMensual_socio:
                h.cantidadMensual_socio - parseInt(action.payload.cantidad),
            }
            : h;
        }),
        carrito: state.carrito.filter((linea, index) => {
          return index !== action.payload.index;
        }),
      };
    case "CANCELAR_CONSULTA_SOCIO":
      return {
        ...state,
        validaciones: [],
        carrito: [],
        mascotas: [],
        historialSocio: [],
        socio: {},
        plan: null,
        alerta: "",
        contratos: null,
        SOCIO_CON_DEUDA: null,
        alimento_consumido: null,
      };
    case "BUSCAR_SOCIO_POR_NUM":
      return {
        ...state,
        socio: {
          dni: action.payload.titular.numero_documento,
          nombre: action.payload.titular.apellido_nombres,
          plan: action.payload.titular.plan,
          version: action.payload.titular.codigo_servicio_mascota24,
          sin_vigencia_hasta: action.payload.titular.sin_vigencia_hasta,
          celular: action.payload.titular.calular,
        },
        integrantes: action.payload.integrantes,
      };
    case "BUSCAR_SOCIO_POR_DNI":
      return {
        ...state,
        contratos: action.payload,
      };
    case "GET_MASCOTAS_POR_CONTRATO":
      return {
        ...state,
        mascotas: action.payload,
        cantidadMascotas: action.payload.length,
      };
    case "SET_ALERTA":
      return {
        ...state,
        alerta: action.payload,
      };
    case "GET_SERVICIOS_PRESTADOR":
      return {
        ...state,
        servicios_prestador: action.payload,
      };
    case "GET_HISTORIAL":
      return {
        ...state,
        historialSocio:
          state.historialSocio.filter((h) => {
            return (
              h.orden === action.payload.orden &&
              h.idPrestacion === action.payload.idPrestacion
            );
          }).length == 0
            ? state.historialSocio.concat(action.payload)
            : state.historialSocio,
      };
    case "CONSUMO_ALIMENTO_BALANCEADO":
      return {
        ...state,
        alimento_consumido: action.payload,
      };
    case "SET_COMPROBANTE":
      return {
        ...state,
        comprobante: action.payload,
      };
    case "SET_IDPRESTADOR":
      return {
        ...state,
        idPrestador: action.payload,
        listaDePrecios: null,
        historialSocio: [],
        validaciones: [],
        carrito: [],
        isGuardia: false,
        cartelGuardia: "",
        admite_pagos_con_tarjeta: false,
        alimento_consumido: null,
      };
    case "SOCIO_CON_DEUDA":
      return {
        ...state,
        SOCIO_CON_DEUDA: true,
      };
    case "CHECK_IF_HORARIO_GUARDIA":
      return {
        ...state,
        isGuardia: action.payload.isGuardia,
        cartelGuardia: action.payload.cartelGuardia,
      };
    case "SET_PAGOS_CON_TARJETA":
      return {
        ...state,
        admite_pagos_con_tarjeta: action.payload,
      };
    case "GET_SERVICIOS_COMPROBANTE":
      return {
        ...state,
        servicios_comprobante: action.payload,
      };
    case "SET_CONSTANTES":
      return {
        ...state,
        constantes: action.payload,
      };
    default:
      return state;
  }
};
